// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

// constants
import { NAV_BUTTON, CAROUSEL_TYPE } from 'shared/components/Carousel/constants';
import ChevronUp from '@nykaa/ui-components/Icons/chevron-left';
import { TEXT_SECONDARY_64 } from 'shared/styles/base';

// styles
const Nav = styled(ChevronUp)<{
  isDisabled: boolean;
  isVertical: boolean;
  type: NAV_BUTTON;
  overflowChevron: boolean;
}>`
  background: transparent;
  border: 0;

  ${({ isDisabled }) =>
    isDisabled &&
    `
    fill: ${TEXT_SECONDARY_64};
  `};

  ${({ overflowChevron }) =>
    overflowChevron &&
    `
    overflow: visible;
  `};

  ${({ theme }) => theme.typography.titleXSmall};

  ${({ isVertical, type }) => {
    if (isVertical === false) {
      if (type === NAV_BUTTON.NEXT) {
        return `transform: rotate(180deg);`;
      }
      // this is required else it will default to line 28
      return;
    }

    if (type === NAV_BUTTON.NEXT) {
      return `transform: rotate(270deg);`;
    } else {
      return `transform: rotate(90deg);`;
    }
  }}
`;

interface INavButtonProps {
  type: NAV_BUTTON;
  oritentation: CAROUSEL_TYPE;
  isDisabled: boolean;
  overflowChevron?: boolean;
}

function NavButton({ type, oritentation, isDisabled, overflowChevron = false }: INavButtonProps) {
  const isVertical = oritentation === CAROUSEL_TYPE.VERTICAL;

  return (
    <Nav
      isDisabled={isDisabled}
      isVertical={isVertical}
      type={type}
      overflowChevron={overflowChevron}
    />
  );
}

export default memo(NavButton);
